import { create } from "zustand";

type FileStore = {
	file?: File;
	setFile: (file: File) => void;
};

export const useFileStore = create<FileStore>((set) => ({
	file: undefined,
	setFile: (file) => set({ file }),
}));
